/**
 * お知らせの種別
 */
export type NotificationType = 'maintenance' | 'important' | 'info' | 'deals';

/**
 * お知らせの既読/未読ステータス
 */
export type NotificationStatus = 'unread' | 'read';

/**
 * お知らせ情報の型定義
 */
export interface Notification {
  id: string;
  type: NotificationType;
  status: NotificationStatus;
  title: string;
  body: string;
  createdAt: string;
}

/**
 * NotificationTypeに対応する表示情報
 */
export const notificationTypeConfig: Record<NotificationType, { label: string; color: string }> = {
  maintenance: { label: 'メンテナンス', color: '#9E9E9E' },
  important: { label: '重要なお知らせ', color: '#F44336' },
  info: { label: 'お知らせ', color: '#2196F3' },
  deals: { label: 'お得な情報', color: '#FF9800' },
};
